import moment from 'moment'
import Papa from 'papaparse'
import {AppConfig} from '@/config/app.config'
import Carga from '@/model/resource/Carga'
import CargaPedidoNroFiscal from '@/model/resource/CargaPedidoNroFiscal'
import {$, HttpBody} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import CargaDanfeRequest from '@/model/request/CargaDanfeRequest'
import {UFInitial} from '@/enums/UFInitial'
import Motorista from '@/model/resource/Motorista'
import MotoristaLoteRequest from '@/model/request/MotoristaLoteRequest'
import {TipoUpload} from '@/enums/TipoUpload'
import {DeliveryStatus} from '@/enums/DeliveryStatus'

const jschardet = require('jschardet')

export async function persistSLA(files: File[]) {
  const file = files[0]

  let passed = 0
  let failed = 0
  let failMessage: {
    line: number,
    reason: string,
  } | null = null

  const request: Carga[] = []
  const messages: any[] = []
  const dateInFutureMessages: any[] = []

  const showPrevisaoReal = Helper.getPermitirDataReal()

  return new Promise((resolve: Function, reject: Function) => {
    const reader = new FileReader()
    reader.onload = async (e: Event) => {
      // @ts-ignore
      const fileData = e.target.result

      const data = convertFile(file, fileData)

      const processSLA = async (data: any) => {
        const blueprint = AppConfig.csvBlueprint.expectedDate
        const normData = Helper.normalizeData(data, blueprint)

        for (let i = 0; i < normData.length; i++) {
          const cargaClass = new Carga()
          const ithLine = {...normData[i], skip: false}
          const idCarga = Number(ithLine.idCargaPk) || null
          const line = i + 2

          if (idCarga == null) {

            if (failMessage == null) {
              failMessage = { line, reason: 'system.error.invalidIdCarga' }
            }

            failed++
            continue
          }

          let resp
          try {
            resp = await cargaClass.getCarga(idCarga, 'getCarga', true)
          } catch (Exception) {
            console.error(Exception)
          }

          if (resp === undefined || resp.data === undefined) {

            if (failMessage == null) {
              failMessage = { line, reason: 'system.error.idCargaNotFound' }
            }

            failed++
            continue
          }

          const carga = resp.data

          const idStatus = carga && carga.statusCarga && carga.statusCarga.idStatusPk

          if (carga === null) {
            if (failMessage == null) {
              failMessage = { line, reason: 'system.error.idStatusNotPending' }
            }

            failed++
            ithLine.skip = true
            continue
          }

          if (idStatus === DeliveryStatus.FINISHED && !showPrevisaoReal) {
            if (failMessage == null) {
              failMessage = { line, reason: 'system.error.deliveryStatusFinishedExpectedDate' }
            }

            failed++
            ithLine.skip = true
            continue
          }

          if (showPrevisaoReal) {
            // TRK-3904 WS - BD - Painel Responsavel - Atualização Data de previsão
            // Quando há a flag, observacaoPrevisao e/ou dataPrevisaoAtualizada incorreta(s) ou vazias não deixa que
            // a carga seja processada, pulando para próxima carga
            if (ithLine.observacaoPrevisao == null) {
              if (failMessage == null) {
                failMessage = { line, reason: 'system.error.emptyObservation' }
              }

              failed++
              ithLine.skip = true
              continue

            } else {
              carga.observacaoPrevisao = ithLine.observacaoPrevisao
            }

            if (ithLine.dataPrevisaoAtualizada != null && !isNaN(Number(ithLine.dataPrevisaoAtualizada))) {
              const days = Math.floor(Number(ithLine.dataPrevisaoAtualizada))
              const time = Number(ithLine.dataPrevisaoAtualizada) - days
              ithLine.dataPrevisaoAtualizada = Helper.parseExcelDate(days, time)
            } else if (ithLine.dataPrevisaoAtualizada == null) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.emptyDateUpdatedForecast'}
              }
              failed++
              ithLine.skip = true
              continue
            }

            const stringDatePrevisaoAtualizada = formatAndValidateDataPrevisaoSla(ithLine.dataPrevisaoAtualizada)

            if (stringDatePrevisaoAtualizada === undefined) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.invaliDateUpdatedForecastFormat'}
              }

              failed++
              ithLine.skip = true
              continue
            } else {
              if (stringDatePrevisaoAtualizada.hour() === 0 && stringDatePrevisaoAtualizada.minute() === 0) {
                stringDatePrevisaoAtualizada.hour(23).minute(59).seconds(59)
              }
              ithLine.dataPrevisaoAtualizada = stringDatePrevisaoAtualizada.format()
              if (ithLine.skip) {
                ithLine.skip = false
              }
              if (carga) {
                if (showPrevisaoReal) {
                  carga.dataPrevisaoAtualizada = ithLine.dataPrevisaoAtualizada

                  if (moment(carga.dataPrevisaoAtualizada).isBefore(new Date())) {
                    dateInFutureMessages.push(['system.error.dateUpdatedForecastPastFromLine', [line]])
                  }
                }

                request.push(carga)
              }
            }
          }

          if (ithLine.dataPrevisao != null && !isNaN(Number(ithLine.dataPrevisao))) {
            const days = Math.floor(Number(ithLine.dataPrevisao))
            const time = Number(ithLine.dataPrevisao) - days
            ithLine.dataPrevisao = Helper.parseExcelDate(days, time)
          }

          const stringDatePrevisao = formatAndValidateDataPrevisaoSla(ithLine.dataPrevisao)

          if (stringDatePrevisao === undefined) {
            if (failMessage == null) {
              failMessage = {line, reason: 'system.error.invalidPrevisaoEntregaFormat'}
            }

            failed++
          } else {
            if (stringDatePrevisao.hour() === 0 && stringDatePrevisao.minute() === 0) {
              stringDatePrevisao.hour(23).minute(59).seconds(59)
            }
            ithLine.dataPrevisao = stringDatePrevisao.format()

            if (ithLine.skip) {
              ithLine.skip = false
            }
            if (carga) {
              carga.dataPrevisao = ithLine.dataPrevisao

              if (moment(carga.dataPrevisao).isBefore(new Date())) {
                dateInFutureMessages.push(['system.error.datePastFromLinePrevisaoEntrega', [line]])
              }

              request.push(carga)
            }
            passed++
          }
        }
      }

      await processSLA(data)

      if (passed < 1) {
        Helper.error($.t('system.error.fileAllLineError'))
        Helper.error($.t('system.info.deliveryWithErrorQuantity', [failed]))
        if (failMessage) {
          Helper.error($.t('system.info.deliveryWithErrorReason', [$.t(failMessage.reason, [failMessage.line])]))
        }
        return reject()
      } else if (failed > 0) {
        messages.push(['system.info.deliveryWithErrorQuantity', [failed]])
        if (failMessage) {
          messages.push(
              ['system.info.deliveryWithErrorReason', [$.t(failMessage.reason, [failMessage.line])]],
          )
        }
      } else {
        for (const dateInFutureMessage of dateInFutureMessages) {
          $.snotify.warning($.t(...dateInFutureMessage))
        }

        messages.push(['system.info.deliverySuccessfullySaved', [passed]])

        await Carga.persistCargaSla(request)
      }

      for (const message of messages) {
        if (message.includes('system.info.deliverySuccessfullySaved')) {
          $.snotify.success($.t(...message))
        } else {
          $.snotify.error($.t(...message))
        }

        await Helper.sleep(500)
      }

      $.modal.closeAll()
      resolve()
    }

    if (file) {
      if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
        reader.readAsArrayBuffer(file)
      } else {
        reader.readAsText(file)
      }
    }
  })
}

const formatAndValidateDataPrevisaoSla = (data: string) => {
  let stringDate

  const dateTimeSecondsWithZone = moment(data, $.t('dateFormat.datetimeSecondsWithZone'), true)
  const dateTime = moment(data, $.t('dateFormat.datetime'), true)
  const date = moment(data, $.t('dateFormat.date'), true)
  const isoDate = moment(data)

  if (dateTimeSecondsWithZone.isValid()) {
  stringDate = dateTimeSecondsWithZone
} else if (dateTime.isValid()) {
  stringDate = dateTime
} else if (date.isValid()) {
  stringDate = date
} else if (isoDate.isValid()) {
  stringDate = isoDate
}
  return stringDate
}

export async function persistOrderNumber(files: File[]) {
  const file = files[0]

  const adaptCsvLineOrderNumber = (obj: any) => ({
    idCargaPk: obj.ID_CARGA === '' ? null : obj.ID_CARGA,
    xpedido: obj.NRO_PEDIDO === '' ? null : `${obj.NRO_PEDIDO}`,
  })

  return new Promise((resolve: Function) => {
    const reader = new FileReader()
    reader.onload = async (e) => {
      // @ts-ignore
      const fileData = e.target.result
      const isTxt = file.name.toLowerCase().endsWith('.txt')

      let data: any

      if (file.name.toLowerCase().endsWith('.csv')) {
        data = Papa.parse(fileData, {
          header: true,
          encoding: checkEncoding(fileData),
          skipEmptyLines: true,
        }).data

        if (!data) {
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            data[key] = adaptCsvLineOrderNumber(data[key])
          }
        }
      } else if (file.name.toLowerCase().endsWith('.xlsx') || file.name.toLowerCase().endsWith('.xls')) {
        data = convertFile(file, fileData)

        if (!data) {
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            data[key] = adaptCsvLineOrderNumber(data[key])
          }
        }
      } else {
        data = convertFile(file, fileData)
      }

      if (isTxt) {
        const list: CargaPedidoNroFiscal[] = []
        data.forEach((item: any) => {
          const carga = new CargaPedidoNroFiscal()
          Object.keys(item).forEach((key) => {
                const match = key.match(/^(Pedido.*)/)
                if (match) {
                  carga.xpedido = item[key]
                }
              })
          carga.nroNotaFiscal = item['N. Nota Fiscal']
          list.push(carga)
        })

        const resp = await CargaPedidoNroFiscal.persistCargaOrderNumber(list)

        $.snotify.success($.t('system.info.deliverySuccessfullySaved', [resp.data.length]))
        $.modal.closeAll()
        resolve()
      } else {
        const list: CargaPedidoNroFiscal[] = []

        data.forEach((item: any) => {
          const carga = new CargaPedidoNroFiscal()
          Helper.plainToClassFromExist(carga, item)
          list.push(carga)
        })

        const resp = await CargaPedidoNroFiscal.persistCargaOrderNumber(list)

        $.snotify.success($.t('system.info.deliverySuccessfullySaved', [resp.data.length]))
        $.modal.closeAll()
        resolve()
      }
    }

    if (file) {
      if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
        reader.readAsArrayBuffer(file)
      } else {
        reader.readAsText(file)
      }
    }
  })
}

export async function persistIssueDate(files: File[]) {
  const file = files[0]

  let passed = 0
  let failed = 0
  let failMessage: {
    line: number,
    reason: string,
  } | null = null

  const request: Carga[] = []
  const messages: any[] = []

  return new Promise((resolve: Function, reject: Function) => {
    const reader = new FileReader()
    reader.onload = async (e: Event) => {
      // @ts-ignore
      const fileData = e.target.result
      const data = convertFile(file, fileData)

      const processIssueDate = async (data: any) => {
        const isTxt = file.name.toLowerCase().endsWith('.txt')

        if (isTxt) {
          const blueprint = AppConfig.txtBlueprint.issueDate
          const normData = Helper.normalizeData(data, blueprint)

          for (let i = 0; i < normData.length; i++) {
            const cargaClass = new Carga()
            const ithLine = {...normData[i], skip: false }
            const xpedido = String(ithLine.xpedido) || null
            const nroNotaFiscal = Number(ithLine.nroNotaFiscal) || null
            const line = i + 2

            if (nroNotaFiscal === null) {
              if (failMessage == null) failMessage = {line, reason: 'system.error.invalidNroNotaFiscal'}

              failed++
              continue
            }

            let resp
            try {
              resp = await cargaClass.getCargaByNotaFiscal(nroNotaFiscal, 'getCarga', true)
            } catch (Exception) {
              console.error(Exception)
            }

            if (resp === undefined || resp.data === undefined) {
              if (failMessage == null) failMessage = {line, reason: 'system.error.cargaNotFound'}

              failed++
              continue
            }

            const carga = resp.data
            const idStatus = carga && carga.statusCarga && carga.statusCarga.idStatusPk

            if (carga === null || idStatus === null || idStatus > 1) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.idStatusNotPending'}
              }

              failed++
              ithLine.skip = true
              continue
            }

            const stringDate = moment(ithLine.dataEmissaoDanfe, 'DD/MM/YY')

            if (stringDate === undefined || !stringDate.isValid()) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.invaliDateFormat'}
              }

              failed++
            } else {
              ithLine.dataEmissaoDanfe = stringDate.format()
              if (ithLine.skip) {
                ithLine.skip = false
              }
              if (carga) {
                carga.dataEmissaoDanfe = ithLine.dataEmissaoDanfe
                carga.xpedido = xpedido

                if (moment(carga.dataEmissaoDanfe).isAfter(new Date())) {
                  $.snotify.warning($.t('system.error.dateInTheFutureAtLine', [line]))
                }

                request.push(carga)
              }
              passed++
            }
          }
        } else {
          const blueprint = AppConfig.csvBlueprint.issueDate
          const normData = Helper.normalizeData(data, blueprint)

          for (let i = 0; i < normData.length; i++) {
            const cargaClass = new Carga()
            const ithLine = {...normData[i], skip: false}
            const idCarga = Number(ithLine.idCargaPk) || null
            const line = i + 2

            if (idCarga == null) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.invalidIdCarga'}
              }

              failed++
              continue
            }

            let resp
            try {
              resp = await cargaClass.getCarga(idCarga, 'getCarga', true)
            } catch (Exception) {
              console.error(Exception)
            }

            if (resp === undefined || resp.data === undefined) {

              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.idCargaNotFound'}
              }

              failed++
              continue
            }

            const carga = resp.data

            const idStatus = carga && carga.statusCarga && carga.statusCarga.idStatusPk

            if (carga === null || idStatus === null || idStatus > 1) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.idStatusNotPending'}
              }

              failed++
              ithLine.skip = true
              continue
            }

            if (ithLine.dataEmissaoDanfe != null && !isNaN(Number(ithLine.dataEmissaoDanfe))) {
              const days = Math.floor(Number(ithLine.dataEmissaoDanfe))
              const time = Number(ithLine.dataEmissaoDanfe) - days
              ithLine.dataEmissaoDanfe = Helper.parseExcelDate(days, time)
            }

            let stringDate

            const dateTimeSecondsWithZone = moment(
              ithLine.dataEmissaoDanfe,
              $.t('dateFormat.datetimeSecondsWithZone'),
              true,
            )
            const dateTime = moment(ithLine.dataEmissaoDanfe, $.t('dateFormat.datetime'), true)
            const date = moment(ithLine.dataEmissaoDanfe, $.t('dateFormat.date'), true)
            const isoDate = moment(ithLine.dataEmissaoDanfe)

            if (dateTimeSecondsWithZone.isValid()) {
              stringDate = dateTimeSecondsWithZone
            } else if (dateTime.isValid()) {
              stringDate = dateTime
            } else if (date.isValid()) {
              stringDate = date
            } else if (isoDate.isValid()) {
              stringDate = isoDate
            }

            if (stringDate === undefined) {
              if (failMessage == null) {
                failMessage = {line, reason: 'system.error.invaliDateFormat'}
              }

              failed++
            } else {
              if (stringDate.hour() === 0 && stringDate.minute() === 0) {
                stringDate.hour(23).minute(59).seconds(59)
              }
              ithLine.dataEmissaoDanfe = stringDate.format()
              if (ithLine.skip) ithLine.skip = false

              if (carga) {
                carga.dataEmissaoDanfe = ithLine.dataEmissaoDanfe

                if (moment(carga.dataEmissaoDanfe).isAfter(new Date())) {
                  $.snotify.warning($.t('system.error.dateInTheFutureAtLine', [line]))
                }

                request.push(carga)
              }

              passed++
            }
          }
        }
      }

      await processIssueDate(data)

      if (passed < 1) {
        if (failMessage) {
          Helper.error($.t(failMessage.reason, [failMessage.line]))
        }
        Helper.error($.t('system.error.fileAllLineError'))
        return reject()
      } else if (failed > 0) {
        messages.push(['system.info.deliveryWithError', [failed]])
        if (failMessage) {
          messages.push([failMessage.reason, [failMessage.line]])
        }
        messages.push(['system.info.deliverySuccessfullySaved', [passed]])
      } else {
        messages.push(['system.info.deliverySuccessfullySaved', [passed]])
      }

      await Carga.persistCargaIssueDate(request)

      for (const message of messages) {
        if (message.includes('system.info.deliverySuccessfullySaved')) {
          $.snotify.success($.t(...message))
        } else {
          $.snotify.error($.t(...message))
        }

        await Helper.sleep(500)
      }

      $.modal.closeAll()
      resolve()
    }

    if (file) {
      if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
        reader.readAsArrayBuffer(file)
      } else {
        reader.readAsText(file)
      }
    }
  })
}

export async function persistWithDanfe(files: File[]) {
  const xmlDanfeFiles = files

  const adaptXmlFile = (obj: any) => {

    // Caso FIAT
    const fiatXpedido = obj.nfeProc.NFe.infNFe.det
      && obj.nfeProc.NFe.infNFe.det.prod
      && obj.nfeProc.NFe.infNFe.det.prod.xPed
      || null

    const usableTransportador = obj.nfeProc.NFe.infNFe.transp.transporta
      && obj.nfeProc.NFe.infNFe.transp.transporta.CNPJ
      && obj.nfeProc.NFe.infNFe.transp.transporta.xNome

    return {
      danfe: obj.nfeProc.protNFe.infProt.chNFe,
      nroNotaFiscal: obj.nfeProc.NFe.infNFe.ide.nNF,
      xpedido: obj.nfeProc.NFe.infNFe.compra && obj.nfeProc.NFe.infNFe.compra.xPed || fiatXpedido || null,
      dataEmissaoDanfe: obj
        && obj.nfeProc
        && obj.nfeProc.NFe
        && obj.nfeProc.NFe.infNFe
        && obj.nfeProc.NFe.infNFe.ide
        && obj.nfeProc.NFe.infNFe.ide.dhEmi
        || null,
      embarcador: {
        responsavel: {
          nomeFantasia: obj.nfeProc.NFe.infNFe.emit.xFant,
          razaoSocial: obj.nfeProc.NFe.infNFe.emit.xNome,
          cnpj: obj.nfeProc.NFe.infNFe.emit.CNPJ,
          telefone: Helper.phone(obj.nfeProc.NFe.infNFe.emit.enderEmit.fone),
        },
        endereco: {
          logradouro: `${obj.nfeProc.NFe.infNFe.emit.enderEmit.xLgr}`,
          nro: obj.nfeProc.NFe.infNFe.emit.enderEmit.nro || null,
          bairro: obj.nfeProc.NFe.infNFe.emit.enderEmit.xBairro,
          cep: obj.nfeProc.NFe.infNFe.emit.enderEmit.CEP,
          cidade: obj.nfeProc.NFe.infNFe.emit.enderEmit.xMun,
          uf: obj.nfeProc.NFe.infNFe.emit.enderEmit.UF,
          complemento: obj.nfeProc.NFe.infNFe.emit.enderEmit.xCpl,
        },
      },
      destinatario: {
        nome: obj.nfeProc.NFe.infNFe.dest.xNome,
        cpfCnpj: obj.nfeProc.NFe.infNFe.dest.CNPJ || obj.nfeProc.NFe.infNFe.dest.CPF,
        email: obj.nfeProc.NFe.infNFe.dest.email,
        telefone: Helper.phone(obj.nfeProc.NFe.infNFe.dest.enderDest.fone),
        endereco: {
          logradouro: obj.nfeProc.NFe.infNFe.dest.enderDest.xLgr,
          nro: obj.nfeProc.NFe.infNFe.dest.enderDest.nro || null,
          bairro: obj.nfeProc.NFe.infNFe.dest.enderDest.xBairro,
          cep: obj.nfeProc.NFe.infNFe.dest.enderDest.CEP,
          cidade: obj.nfeProc.NFe.infNFe.dest.enderDest.xMun,
          uf: obj.nfeProc.NFe.infNFe.dest.enderDest.UF,
          complemento: obj.nfeProc.NFe.infNFe.dest.enderDest.xCpl,
        },
      },
      transportador: {
        responsavel: usableTransportador ? {
          razaoSocial: obj.nfeProc.NFe.infNFe.transp.transporta.xNome,
          cnpj: obj.nfeProc.NFe.infNFe.transp.transporta.CNPJ,
        } : null,
      },
      notificacaoSmsAtlas: Helper.phone(obj.TELEFONE_NOTIFICACAO),
      notificacaoEmailAtlas: obj.EMAIL_NOTIFICACAO,
      cdCorreio: obj.CODIGO_CORREIOS === '' ? null : obj.CODIGO_CORREIOS,
    }
  }

  const recursivelyReadXmlDanfeFiles = (index: number, list: Carga[], errors: string[], cb: Function) => {
    const reader = new FileReader()
    reader.onload = (e: Event) => {
      // @ts-ignore
      const fileData = e.target.result

      const xml = parseXml(fileData)
      const carga = new Carga()

      try {
        Helper.plainToClassFromExist(carga, adaptXmlFile(xml))

        const devoValidarDest = !Helper.getClienteExportacao()

        if ((carga.destinatario && !carga.destinatario.endereco) && (!carga.destinatario.cpfCnpj) && devoValidarDest) {
          errors.push(`${xmlDanfeFiles[index].name}: ${$.t('system.error.danfeInvalidDocument')}`)
        }

        if ((carga.destinatario && carga.destinatario.endereco.uf !== UFInitial.EX) && (!carga.destinatario.cpfCnpj)
            && devoValidarDest) {
          errors.push(`${xmlDanfeFiles[index].name}: ${$.t('system.error.danfeInvalidDocument')}`)
        }

        list.push(carga)
      } catch (e) {/* Ignore */}

      recursivelyReadXmlDanfeFiles(++index, list, errors, cb)
    }

    if (xmlDanfeFiles.length > index) {
      const file = xmlDanfeFiles[index]

      if (!file.name.toLowerCase().endsWith('.xml')) {
        Helper.abort(`${file.name}: ${$.t('system.error.fileInvalidFormat')}`)
      }

      if (file) {
        reader.readAsText(file)
      }
    } else {
      cb(list, errors)
    }
  }

  const cadastrarDanfesOfXml = async (list: Carga[]) => {
    const request = new CargaDanfeRequest() as CargaDanfeRequest
    request.cargas = list
    await Helper.importFileToS3(request, TipoUpload.CADASTRO_LOTE_COM_DANFE)

    $.snotify.success($.t('system.info.pleaseWaitForImport'))
    $.modal.closeAll()
  }

  return new Promise((resolve: Function, reject: Function) => {
    recursivelyReadXmlDanfeFiles(0, [], [], async (list: Carga[], errors: string[]) => {
      if (errors.length) {
        errors.forEach((error) => {
          Helper.error(error, '', false, {
            timeout: 4000,
          })
        })
        reject()
      } else {
        await cadastrarDanfesOfXml(list)
        resolve()
      }
    })
  })
}

export async function cadastrarMotoristas(files: File[]) {
  const file = files[files.length - 1]
  const req = new MotoristaLoteRequest()
  req.viaPainel = true

  const adaptCsvLineEntregadores = (obj: any, line: number) => {
    let dataNascimento = obj.DATA_NASCIMENTO || null
    const date = moment(dataNascimento, $.t('dateFormat.date'), true)
    const inputDate = moment(dataNascimento, $.t('dateFormat.inputdate'), true)
    const inputDateAlt = moment(dataNascimento, $.t('dateFormat.inputdateAlt'), true)

    if (inputDateAlt.isValid()) {
      dataNascimento = inputDateAlt.format()
    } else if (inputDate.isValid()) {
      dataNascimento = inputDate.format()
    } else if (date.isValid()) {
      dataNascimento = date.format()
    } else {
      $.await.done('persistMotorista')
      if (dataNascimento == null) {
        Helper.abort($.t('system.error.birthDateEmpty', [line + 1]))
      } else {
        Helper.abort($.t('system.error.birthDateInvalid', [line + 1]))
      }

    }

    return  {
    nome: obj.NOME === '' ? null : obj.NOME,
    cpf: obj.CPF === '' ? null : obj.CPF,
    rg: obj.RG === '' ? null : obj.RG,
    celular: obj.CELULAR === '' ? null : obj.CELULAR,
    telefoneFixo: obj.TELEFONE_FIXO === '' ? null : obj.TELEFONE_FIXO,
    dataNascimento,
    email: obj.EMAIL === '' ? null : obj.EMAIL,
    placaVeiculo: obj.PLACA_VEICULO === '' ? null : obj.PLACA_VEICULO,
    tipoVeiculo: obj.TIPO_VEICULO === '' ? null : obj.TIPO_VEICULO,
    marcaVeiculo: obj.MARCA_VEICULO === '' ? null : obj.MARCA_VEICULO,
    tipoCarroceria: obj.TIPO_CARROCERIA === '' ? null : obj.TIPO_CARROCERIA,
    placaCarroceira: obj.PLACA_CARROCERIA === '' ? null : obj.PLACA_CARROCERIA,
    antt: obj.ANTT === '' ? null : obj.ANTT,
    cnh: obj.CNH === '' ? null : obj.CNH,
    endereco: {
      logradouro: obj.ENDERECO_LOGRADOURO === '' ? null : obj.ENDERECO_LOGRADOURO,
      bairro: obj.ENDERECO_BAIRRO === '' ? null : obj.ENDERECO_BAIRRO,
      cep: obj.ENDERECO_CEP === '' ? null : obj.ENDERECO_CEP,
      cidade: obj.ENDERECO_CIDADE === '' ? null : obj.ENDERECO_CIDADE,
      uf: obj.ENDERECO_UF === '' ? null : obj.ENDERECO_UF,
      pais: obj.ENDERECO_PAIS === '' ? null : obj.ENDERECO_PAIS,
      complemento: obj.ENDERECO_COMPLEMENTO === '' ? null : obj.ENDERECO_COMPLEMENTO,
      nro: obj.ENDERECO_NUMERO === '' ? null : obj.ENDERECO_NUMERO,
    },
  }}

  return new Promise((resolve: Function) => {
    const reader = new FileReader()
    let line = 1
    reader.onload = async (e) => {
      // @ts-ignore
      const fileData = e.target.result

      let data: any

      if (file.name.toLowerCase().endsWith('.csv')) {
        data = Papa.parse(fileData, {
          header: true,
          encoding: checkEncoding(fileData),
          skipEmptyLines: true,
        }).data

        if (!data) {
          $.await.done('persistMotorista')
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            data[key] = adaptCsvLineEntregadores(data[key], line)
            line++
          }
        }
      } else if (file.name.toLowerCase().endsWith('.xlsx') || file.name.toLowerCase().endsWith('.xls')) {
        data = convertFile(file, fileData)

        if (!data) {
          $.await.done('persistMotorista')
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const obj = data[key]
            try {
              data[key] = adaptCsvLineEntregadores(obj, line)
              line++
            } catch {
              $.await.done('persistMotorista')
              Helper.abort($.t('system.error.fileInvalidFormat'))
            }
          }
        }
      } else {
        data = convertFile(file, fileData)
      }

      req.motoristas = []

      data.forEach((item: any) => {
        const motorista = new Motorista()
        Helper.plainToClassFromExist(motorista, item)
        req.motoristas.push(motorista)
      })

      const resp = await Motorista.cadastroMotoristaLote(req)
      $.snotify.success($.t('system.info.driversSuccessfullySaved'))
      $.modal.closeAll()
      resolve()
    }

    if (file) {
      if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
        reader.readAsArrayBuffer(file)
      } else {
        reader.readAsText(file)
      }
    }
  })
}

export async function persistWithoutDanfe(files: File[]) {
  const file = files[0]
  const req = new CargaDanfeRequest()
  req.viaPainel = true

  const adaptCsvLineSemDanfe = (obj: any) => ({
    motorista: {
      idMotoristaPk:
        obj.ID_DO_ENTREGADOR === '' || obj.ID_DO_ENTREGADOR === undefined
          ? null
          : obj.ID_DO_ENTREGADOR,
    },
    nroNotaFiscal: obj.NRO_DOCUMENTO === '' ? null : obj.NRO_DOCUMENTO,
    serialNumber: obj.SERIAL_NUMBER === '' ? null : obj.SERIAL_NUMBER,
    dataEmissaoDanfe: obj.DATA_EMISSAO_DANFE === '' ? null : obj.DATA_EMISSAO_DANFE,
    embarcador: {
      responsavel: {
        nomeFantasia: obj.EMBARCADOR_NOME_FANTASIA === '' ? null : obj.EMBARCADOR_NOME_FANTASIA,
        razaoSocial: obj.EMBARCADOR_RAZAO_SOCIAL === '' ? null : obj.EMBARCADOR_RAZAO_SOCIAL,
        cnpj: obj.EMBARCADOR_CNPJ === '' ? null : obj.EMBARCADOR_CNPJ,
        telefone: obj.EMBARCADOR_TELEFONE === '' ? null : obj.EMBARCADOR_TELEFONE,
      },
      endereco: {
        logradouro: obj.EMBARCADOR_LOGRADOURO === '' ? null : obj.EMBARCADOR_LOGRADOURO,
        bairro: obj.EMBARCADOR_BAIRRO === '' ? null : obj.EMBARCADOR_BAIRRO,
        cep: obj.EMBARCADOR_CEP === '' ? null : obj.EMBARCADOR_CEP,
        cidade: obj.EMBARCADOR_CIDADE === '' ? null : obj.EMBARCADOR_CIDADE,
        uf: obj.EMBARCADOR_UF === '' ? null : obj.EMBARCADOR_UF,
      },
    },
    destinatario: {
      nome: obj.DESTINATARIO_NOME === '' ? null : obj.DESTINATARIO_NOME,
      cpfCnpj: obj.DESTINATARIO_CPF_CNPJ === '' ? null : obj.DESTINATARIO_CPF_CNPJ,
      email: obj.DESTINATARIO_EMAIL === '' ? null : obj.DESTINATARIO_EMAIL,
      telefone: obj.DESTINATARIO_TELEFONE === '' ? null : obj.DESTINATARIO_TELEFONE,
      endereco: {
        logradouro: obj.DESTINATARIO_LOGRADOURO === '' ? null : obj.DESTINATARIO_LOGRADOURO,
        nro: obj.DESTINATARIO_NUMERO === '' ? null : obj.DESTINATARIO_NUMERO,
        bairro: obj.DESTINATARIO_BAIRRO === '' ? null : obj.DESTINATARIO_BAIRRO,
        cep: obj.DESTINATARIO_CEP === '' ? null : obj.DESTINATARIO_CEP,
        cidade: obj.DESTINATARIO_CIDADE === '' ? null : obj.DESTINATARIO_CIDADE,
        uf: obj.DESTINATARIO_UF === '' ? null : obj.DESTINATARIO_UF,
        latitude: obj.DESTINATARIO_LATITUDE === '' ? null : obj.DESTINATARIO_LATITUDE,
        longitude: obj.DESTINATARIO_LONGITUDE === '' ? null : obj.DESTINATARIO_LONGITUDE,
      },
    },
    transportador: {
      responsavel: {
        razaoSocial: obj.TRANSPORTADOR_RAZAO_SOCIAL === '' ? null : obj.TRANSPORTADOR_RAZAO_SOCIAL,
        cnpj: obj.TRANSPORTADOR_CNPJ === '' ? null : obj.TRANSPORTADOR_CNPJ,
      },
      endereco: {
        logradouro: obj.TRANSPORTADOR_LOGRADOURO === '' ? null : obj.TRANSPORTADOR_LOGRADOURO,
        bairro: obj.TRANSPORTADOR_BAIRRO === '' ? null : obj.TRANSPORTADOR_BAIRRO,
        cep: obj.TRANSPORTADOR_CEP === '' ? null : obj.TRANSPORTADOR_CEP,
        cidade: obj.TRANSPORTADOR_CIDADE === '' ? null : obj.TRANSPORTADOR_CIDADE,
        uf: obj.TRANSPORTADOR_UF === '' ? null : obj.TRANSPORTADOR_UF,
      },
    },
    notificacaoSmsAtlas: Helper.phone(obj.TELEFONE_NOTIFICACAO),
    notificacaoEmailAtlas: obj.EMAIL_NOTIFICACAO,
    cdCorreio: obj.CODIGO_CORREIOS === '' ? null : obj.CODIGO_CORREIOS,
  })

  const adaptCieloLineSemDanfe = (obj: any) => {
    req.cielo = true

    // caso especial do TIPO_SERVIÇO devido ao problema de acentuação
    Object.keys(obj).forEach((key) => {
      const match = key.match(/^(TIPO_SERVI.+)$/)
      if (match) {
        obj.TIPO_SERVICO = obj[key]
      }
    })

    let pontoReferenciaEntrega = ''
    if (obj.TIPO_SERVICO) pontoReferenciaEntrega += `${obj.TIPO_SERVICO} `
    if (obj.DDD && obj.FONE) {
      pontoReferenciaEntrega += `(${obj.DDD})`
      pontoReferenciaEntrega += `${obj.FONE} `
    }
    if (obj.MODELO) pontoReferenciaEntrega += `${obj.MODELO} `
    if (obj.NR_LOGICO) pontoReferenciaEntrega += `${obj.NR_LOGICO} `
    if (obj.CHAMADO_GTEC) pontoReferenciaEntrega += `${obj.CHAMADO_GTEC} `
    if (obj['HORARIO DE FUNCIONAMENTO']) pontoReferenciaEntrega += `${obj['HORARIO DE FUNCIONAMENTO']} `
    if (obj.OBSERVACAO) pontoReferenciaEntrega += `${obj.OBSERVACAO} `
    pontoReferenciaEntrega = pontoReferenciaEntrega.trim()

    let dataPrevisao = obj.DT_HR_FINAL_ATENDIMENTO || null

    const dateTimeSecondsWithZone = moment(
      dataPrevisao,
      $.t('dateFormat.datetimeSecondsWithZone'),
      true,
    )
    const dateTime = moment(dataPrevisao, $.t('dateFormat.datetime'), true)
    const date = moment(dataPrevisao, $.t('dateFormat.date'), true)
    const isoDate = moment(dataPrevisao)

    if (dateTimeSecondsWithZone.isValid()) {
      dataPrevisao = dateTimeSecondsWithZone.format()
    } else if (dateTime.isValid()) {
      dataPrevisao = dateTime.format()
    } else if (date.isValid()) {
      dataPrevisao = date.format()
    } else if (isoDate.isValid()) {
      dataPrevisao = isoDate.format()
    } else {
      const days = Math.floor(Number(dataPrevisao))
      const time = Number(dataPrevisao) - days
      const date = Helper.parseExcelDate(days, time)
      dataPrevisao = moment(date, $.t('dateFormat.datetime')).format()
    }

    let nomeDestinatario = ''
    if (obj.NOME_FANTASIA) nomeDestinatario += obj.NOME_FANTASIA
    if (obj.NOME_FANTASIA && obj['RAZAO SOCIAL']) nomeDestinatario += ' - '
    if (obj['RAZAO SOCIAL']) nomeDestinatario += obj['RAZAO SOCIAL']

    let telefoneDestinatario = ''
    if (obj.DDD) telefoneDestinatario += `(${obj.DDD}) `
    if (obj.FONE) telefoneDestinatario += obj.FONE

    return {
      sigla: obj.TIPO_SERVICO || null,
      pontoReferenciaEntrega,
      dataPrevisao,
      nroNotaFiscal: obj.REFERENCIA ? `${obj.REFERENCIA}` : null,
      xpedido: obj.CHAMADO_GTEC ? `${obj.CHAMADO_GTEC}` : null,
      observacao: obj.Acesso ? `${obj.Acesso}` : null,
      cargaInfo: {
        nroCte: obj.MAQUINETA ? `${obj.MAQUINETA}` : null,
      },
      embarcador: {
        // pegar o responsavel de id=18625 (cielo)
      },
      destinatario: {
        nome: nomeDestinatario,
        cpfCnpj: obj.CNPJ ? `${obj.CNPJ}` : null,
        email: '',
        telefone: telefoneDestinatario,
        endereco: {
          logradouro: obj.ENDERECO || null,
          bairro: obj.BAIRRO || null,
          cep: obj.CEP ? `${obj.CEP}` : null,
          cidade: obj.CIDADE || null,
          uf: obj.UF || null,
        },
      },
      transportador: {
        responsavel: {
          idResponsavelPk: obj.FILIAL_DESIGNADA || null, // pegar o cnpj e razao social no WS
        },
        endereco: {
          // pegar o endereço do responsavel de id=18625 (cielo)
        },
      },
    }
  }

  const isCieloObj = (obj: any) => {
    const cieloKeys = [
      'TIPO_SERVIÇO',
      'SERVICO_CONTRATADO',
      'TIPO_EQUIPAMENTO',
      'MODELO',
      'NR_LOGICO',
      'RAZAO SOCIAL',
      'NOME_FANTASIA',
      'ENDERECO',
      'BAIRRO',
      'CEP',
      'CIDADE',
      'UF',
      'DDD',
      'FONE',
      'CONTATO',
      'DT_HR_FINAL_ATENDIMENTO',
      'PRESTADOR_SERVICO',
      'FILIAL_DESIGNADA',
      'REFERENCIA',
      'CHAMADO_GTEC',
      'MAQUINETA',
      'MOTIVO_EVENTO',
      'HORARIO DE FUNCIONAMENTO',
      'NOVO_REMANEJADO',
      'RAMO_ATIVIDADE',
      'Acesso',
      'CNPJ',
      'OBSERVACAO',
    ]

    let i = 10
    for (const key of Object.keys(obj)) {
      if (cieloKeys.includes(key)) {
        if (--i === 0) {
          return true
        }
      }
    }

    return false
  }

  return new Promise((resolve: Function) => {
    const reader = new FileReader()
    reader.onload = async (e) => {
      // @ts-ignore
      const fileData = e.target.result

      let data: any
      let isCielo: boolean | null = null

      if (file.name.toLowerCase().endsWith('.csv')) {
        data = Papa.parse(fileData, {
          header: true,
          encoding: checkEncoding(fileData),
          skipEmptyLines: true,
        }).data

        if (!data) {
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            data[key] = adaptCsvLineSemDanfe(data[key])
          }
        }
      } else if (file.name.toLowerCase().endsWith('.xlsx') || file.name.toLowerCase().endsWith('.xls')) {
        data = convertFile(file, fileData)

        if (!data) {
          Helper.abort($.t('system.error.fileInvalidFormat'))
        }

        if (isCieloObj(data[0])) {
          data = (data || []).filter((item: any) => Boolean(item.Acesso))
        }

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const obj = data[key]
            if (isCieloObj(obj)) {
              isCielo = true
              try {
                data[key] = adaptCieloLineSemDanfe(obj)
              } catch {
                Helper.abort($.t('system.error.fileInvalidFormat'))
              }
            } else {
              isCielo = false
              try {
                data[key] = adaptCsvLineSemDanfe(obj)
              } catch {
                Helper.abort($.t('system.error.fileInvalidFormat'))
              }
            }
          }
        }
      } else {
        data = convertFile(file, fileData)
      }

      req.cargas = []

      if (isCielo) {
        Helper.info($.t('system.info.cieloFileDetected'))
      }

      data.forEach((item: any) => {
        const carga = new Carga()
        Helper.plainToClassFromExist(carga, item)
        req.cargas.push(carga)
      })

      await Helper.importFileToS3(req, TipoUpload.CADASTRO_LOTE_SEM_DANFE)

      $.snotify.success($.t('system.info.pleaseWaitForImport'))
      $.modal.closeAll()
      resolve()
    }

    if (file) {
      if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
        reader.readAsArrayBuffer(file)
      } else {
        reader.readAsText(file)
      }
    }
  })
}

export async function persistWithNotfis(files: File[]) {
  const promise = []

  let i = 0
  for (const file of files) {
    const reader = new FileReader()
    promise[i++] = new Promise((resolve) => reader.onload = (() => (e: Event) => {
      // @ts-ignore
      resolve(`${e.target.result}\n`)
    })())
    reader.readAsText(file)
  }

  const result = await Promise.all(promise)
  let content = ''

  result.forEach((str) => {
    content += `${str}\n`
  })

  Helper.info('system.info.pleaseWait')

  await Helper.importFileToS3(content, TipoUpload.CADASTRO_LOTE_COM_NOTIFIS)

  $.snotify.success($.t('system.info.pleaseWaitForImport'))

  $.modal.closeAll()
}

export async function persistWithCTE(files: File[], readNfs: boolean, emitenteTransportador?: boolean) {
  const xmlDanfeFiles = files
  let docs: string[] = []
  let isDanfe: boolean | null = null

  const adaptXmlFile = (obj: any) => {
    const expedKey = obj.cteProc.CTe.infCte.exped ? 'exped' : 'rem'
    const expedEnderKey = obj.cteProc.CTe.infCte.exped ? 'enderExped' : 'enderReme'
    const destKey = obj.cteProc.CTe.infCte.receb ? 'receb' : 'dest'
    const destEnderKey = obj.cteProc.CTe.infCte.receb ? 'enderReceb' : 'enderDest'
    const toma4 = obj.cteProc.CTe.infCte.ide.toma4
    const enderToma = toma4 && toma4.enderToma
    const dPrevAereo = obj.cteProc.CTe.infCte.infCTeNorm
        && obj.cteProc.CTe.infCte.infCTeNorm.infModal
        && obj.cteProc.CTe.infCte.infCTeNorm.infModal.aereo
        && obj.cteProc.CTe.infCte.infCTeNorm.infModal.aereo.dPrevAereo
        || null
    const nOCA = obj.cteProc.CTe.infCte.infCTeNorm
        && obj.cteProc.CTe.infCte.infCTeNorm.infModal
        && obj.cteProc.CTe.infCte.infCTeNorm.infModal.aereo
        && obj.cteProc.CTe.infCte.infCTeNorm.infModal.aereo.nOCA
        || null
    const serialNumber = obj.cteProc
        && obj.cteProc.CTe
        && obj.cteProc.CTe.infCte
        && obj.cteProc.CTe.infCte.compl
        && obj.cteProc.CTe.infCte.compl.ObsCont
        && obj.cteProc.CTe.infCte.compl.ObsCont.xTexto
        || null

    if (readNfs) {
      const infDoc: any | any[] = obj.cteProc.CTe.infCte.infCTeNorm && obj.cteProc.CTe.infCte.infCTeNorm.infDoc
      const infNFe = infDoc.infNFe
      const infNF = infDoc.infNF

      if (infNFe) {
        isDanfe = true
        if (infNFe instanceof Array) {
          docs = infNFe.map((item) => item.chave)
        } else {
          docs = [infNFe.chave]
        }
      } else if (infNF) {
        isDanfe = false
        if (infNF instanceof Array) {
          docs = infNF.map((item) => item.nDoc)
        } else {
          docs = [infNF.nDoc]
        }
      } else {
        isDanfe = null
        docs = []
      }
    }

    const transportador = {
      responsavel: {
        razaoSocial: obj.cteProc.CTe.infCte.emit.xNome,
        cnpj: obj.cteProc.CTe.infCte.emit.CNPJ,
      },
      endereco: {
        logradouro: obj.cteProc.CTe.infCte.emit.enderEmit.xLgr + ', '
           + obj.cteProc.CTe.infCte.emit.enderEmit.xCpl,
        nro: obj.cteProc.CTe.infCte.emit.enderEmit.nro || null,
        bairro: obj.cteProc.CTe.infCte.emit.enderEmit.xBairro,
        cep: obj.cteProc.CTe.infCte.emit.enderEmit.CEP,
        cidade: obj.cteProc.CTe.infCte.emit.enderEmit.xMun,
        uf: obj.cteProc.CTe.infCte.emit.enderEmit.UF,
      },
    }

    const complementoDestinatario = obj.cteProc.CTe.infCte[destKey][destEnderKey].xCpl ?
        ', ' + obj.cteProc.CTe.infCte[destKey][destEnderKey].xCpl : ''

    const destinatario = {
      nome: obj.cteProc.CTe.infCte[destKey].xNome,
      cpfCnpj: obj.cteProc.CTe.infCte[destKey].CNPJ || obj.cteProc.CTe.infCte[destKey].CPF,
      telefone: Helper.phone(obj.cteProc.CTe.infCte[destKey].fone),
      endereco: {
        logradouro: obj.cteProc.CTe.infCte[destKey][destEnderKey].xLgr + complementoDestinatario,
        nro: obj.cteProc.CTe.infCte[destKey][destEnderKey].nro || null,
        bairro: obj.cteProc.CTe.infCte[destKey][destEnderKey].xBairro,
        cep: obj.cteProc.CTe.infCte[destKey][destEnderKey].CEP,
        cidade: obj.cteProc.CTe.infCte[destKey][destEnderKey].xMun,
        uf: obj.cteProc.CTe.infCte[destKey][destEnderKey].UF,
      },
    }

    const embarcador = emitenteTransportador ? transportador : {
      responsavel: {
        razaoSocial: toma4 ? toma4.xNome : obj.cteProc.CTe.infCte[expedKey].xNome,
        cnpj: toma4 ? toma4.CNPJ : obj.cteProc.CTe.infCte[expedKey].CNPJ,
        telefone: toma4 ? null : Helper.phone(obj.cteProc.CTe.infCte[expedKey].fone),
      },
      endereco: {
        logradouro: (enderToma ? enderToma.xLgr : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].xLgr) + ', '
          + (enderToma ? enderToma.xCPl : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].xCpl),
        nro: (enderToma ? enderToma.nro : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].nro) || null ,
        bairro: enderToma ? enderToma.xBairro : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].xBairro,
        cep: enderToma ? enderToma.CEP : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].CEP,
        cidade: enderToma ? enderToma.xMun : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].xMun,
        uf: enderToma ? enderToma.UF : obj.cteProc.CTe.infCte[expedKey][expedEnderKey].UF,
      },
    }

    return {
      danfe: null,
      cte: obj.cteProc.protCTe.infProt.chCTe,
      nroNotaFiscal: obj.cteProc.CTe.infCte.ide.nCT,
      serialNumber,
      dataEmissaoDanfe: obj
      && obj.nfeProc
      && obj.nfeProc.NFe
      && obj.nfeProc.NFe.infNFe
      && obj.nfeProc.NFe.infNFe.ide
      && obj.nfeProc.NFe.infNFe.ide.dhEmi
      || null,
      embarcador,
      destinatario,
      transportador,
      dataPrevisao: dPrevAereo ? moment(dPrevAereo, 'YYYY-MM-DD').add(1, 'days').subtract(1, 'seconds').format() : null,
      xpedido: nOCA,
    }
  }

  const recursivelyReadXmlDanfeFiles = (index: number, list: Carga[], errors: string[], cb: Function) => {
    const reader = new FileReader()
    reader.onload = (e: Event) => {
      // @ts-ignore
      const fileData = e.target.result

      const xml = parseXml(fileData)
      const carga = new Carga()

      try {
        const data = adaptXmlFile(xml)
        Helper.plainToClassFromExist(carga, data)
        const devoValidarDest = !Helper.getClienteExportacao()

        if ((carga.destinatario && !carga.destinatario.endereco) && !carga.destinatario.cpfCnpj && devoValidarDest) {
          errors.push(`${xmlDanfeFiles[index].name}: ${$.t('system.error.danfeInvalidDocument')}`)
        }

        if ((carga.destinatario && carga.destinatario.endereco.uf !== UFInitial.EX) && !carga.destinatario.cpfCnpj
            && devoValidarDest) {

          errors.push(`${xmlDanfeFiles[index].name}: ${$.t('system.error.danfeInvalidDocument')}`)
        }

        if (readNfs) {
          if (!docs.length) {
            errors.push(`${xmlDanfeFiles[index].name}: ${$.t('system.error.nfsInvalidFormat')}`)
          }

          for (const doc of docs) {
            const cargaClone = carga.clone()

            if (isDanfe) {
              cargaClone.danfe = doc
              cargaClone.nroNotaFiscal = Number(doc.substring(25, 34)).toString()
            } else {
              cargaClone.nroNotaFiscal = Number(doc).toString()
            }

            list.push(cargaClone)
          }
        } else {
          list.push(carga)
        }
      } catch (e) {
        console.error(e)
      }

      recursivelyReadXmlDanfeFiles(++index, list, errors, cb)
    }

    if (xmlDanfeFiles.length > index) {
      const file = xmlDanfeFiles[index]

      if (!file.name.toLowerCase().endsWith('.xml')) {
        Helper.abort(`${file.name}: ${$.t('system.error.fileInvalidFormat')}`)
      }

      if (file) {
        reader.readAsText(file)
      }
    } else {
      cb(list, errors)
    }
  }

  const cadastrarDanfesOfXml = async (list: Carga[]) => {
    const request = new CargaDanfeRequest() as CargaDanfeRequest
    request.cargas = list

    if (readNfs) {
      await Helper.importFileToS3(request, TipoUpload.CADASTRO_LOTE_COM_CTE_NFS)
    } else {
      await Helper.importFileToS3(request, TipoUpload.CADASTRO_LOTE_COM_CTE)
    }

    $.snotify.success($.t('system.info.pleaseWaitForImport'))
    $.modal.closeAll()
  }

  return new Promise((resolve: Function, reject: Function) => {
    recursivelyReadXmlDanfeFiles(0, [], [], async (list: Carga[], errors: string[]) => {
      if (errors.length) {
        errors.forEach((error) => {
          Helper.error(error, '', false, {
            timeout: 4000,
          })
        })
        reject()
      } else {
        await cadastrarDanfesOfXml(list)
        resolve()
      }
    })
  })
}

export function convertFile(file: File, fileData: any) {
  let data: any

  if (file.name.toLowerCase().endsWith('.json')) {
    // Case JSON
    data = JSON.parse(fileData)
    if (!Array.isArray(data)) {
      Helper.abort($.t('system.error.fileInvalidFormat'))
    }
  } else if (file.name.toLowerCase().endsWith('.xml')) {
    // Case XML
    data = parseXml(fileData)
    if (!data || !data.cargas) {
      Helper.abort($.t('system.error.fileInvalidFormat'))
    }
    data = data.cargas.carga
    if (!Array.isArray(data)) {
      data = [data]
    }
  } else if (file.name.toLowerCase().endsWith('.csv')) {
    // Case CSV
    data = Papa.parse(fileData, {
      header: true,
      encoding: checkEncoding(fileData),
      skipEmptyLines: true,
      delimiter: ';',
    }).data
  } else if (file.name.toLowerCase().endsWith('.xls') || file.name.toLowerCase().endsWith('.xlsx')) {
    // Case XLS/XLSX
    data = Helper.parseXlsx(fileData)
  } else if (file.name.toLowerCase().endsWith('.txt')) {
    // Case TXT
    data = Helper.parseTxt(fileData)
  }

  if (!data) {
    Helper.abort($.t('system.error.fileInvalidFormat'))
  }

  return data
}

export function parseXml(xml: string) {
  let dom

  if (DOMParser) {
    dom = (new DOMParser()).parseFromString(xml, 'text/xml')
  } else if (ActiveXObject) {
    dom = new ActiveXObject('Microsoft.XMLDOM')
    dom.async = false

    if (!dom.loadXML(xml)) {
      throw Error(`${dom.parseError.reason} ${dom.parseError.srcText}`)
    }
  } else {
    throw Error('cannot parse xml string!')
  }

  const parseNode = (xmlNode: any, result: any) => {
    let jsonNode: any = {}
    const existing = result[xmlNode.nodeName]

    if (xmlNode.attributes) {
      for (const attr of xmlNode.attributes) {
        jsonNode[attr.nodeName] = attr.nodeValue
      }
    }

    for (const node of xmlNode.childNodes) {
      if (node.nodeName === '#text') {
        if (node.nodeValue.trim().length) {
          jsonNode = node.nodeValue.trim()
        }
      } else {
        parseNode(node, jsonNode)
      }
    }

    if (Object.keys(jsonNode).length > 0) {
      if (existing) {
        if (!Array.isArray(existing)) {
          result[xmlNode.nodeName] = [existing, jsonNode]
        } else {
          result[xmlNode.nodeName].push(jsonNode)
        }
      } else {
        result[xmlNode.nodeName] = jsonNode
      }
    }
  }

  const result = {}
  if (dom.childNodes.length) {
    try {
      parseNode(dom.childNodes[0], result)
    } catch (e) {
      return {}
    }
  }

  return result
}

export function checkEncoding(str: string) {
  let encoding = jschardet.detect(str)
  encoding = encoding.encoding

  if (encoding === 'windows-1252') {
    encoding = 'ANSI'
  }

  return encoding
}
